import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Row, Table } from "reactstrap";

import { useNavigate } from "react-router-dom";
import { BiEditAlt, BiTrash } from "react-icons/bi";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { BiLeftArrowAlt } from "react-icons/bi";
import useAuth from "../../hooks/useAuth";

const HomePageServiceView = () => {
  const { auth } = useAuth();

  const [modal, openModal] = useState(false);
  const [services, setServices] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const source = axios.CancelToken.source();
    const getservices = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/homepage-services/find-all`,
          {
            cancelToken: source.token,
          }
        );
        setServices(res.data);
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log("cancelled");
        } else {
          throw error;
        }
      }
    };

    getservices();
    return () => {
      source.cancel();
    };
  }, []);

  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Home Page Services List</h5>
      </Row>
      <Row>
        <Table responsive hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Description</th>
              <th>Image</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {services.map((services) => (
              <tr key={services.id}>
                <td>{services.id}</td>
               
                <td style={{ wordBreak: "break-all" }}>
                  {services.serviceName}
                </td>
               
                <td
                  style={{ wordBreak: "break-all" }}
                  dangerouslySetInnerHTML={{
                    __html: services.serviceDesc
                  }}
                ></td>
                <td>
                  <img
                    style={{ width: 120 }}
                    src={
                      process.env.REACT_APP_API_IMAGE_URI.substring(
                        0,
                        process.env.REACT_APP_API_IMAGE_URI.indexOf("/api")
                      ) +
                      `${services.serviceImg.substring(
                        services.serviceImg.indexOf("/uploads")
                      )}`
                    }
                    alt="services-img"
                  ></img>
                </td>
                <td>
                  <BiEditAlt
                    className="edit_icon icon_hover"
                    onClick={() => navigate(`/homepage-services/edit/${services.id}`)}
                    size={30}
                  />
                  {/* <BiTrash className="delete_icon icon_hover" onClick={(event) => handleDelete(event, services.id)} size={20} />      */}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Row>
      {/* {services && (
        <Row sm="12" className="mt-4 text-center">
          <Link to={"/services/add"} className="go_back">
            <BiLeftArrowAlt size={30} /> Go to Add Service
          </Link>
        </Row>
      )} */}
    </div>
  );
};

export default HomePageServiceView;